<template>
  <div class="common-layout">
    <el-container>
      <img
        class="double-icon"
        src="../assets/icons/icon-on-top-of-contact.svg"
      />
      <el-aside id="aside-home">
        <!-- image from css background -->
      </el-aside>
      <el-main>
        <div class="app-content-container">
          <img
            class="naps-logo"
            src="../assets/icons/Naps-navigation-logo.svg"
          />
          <h1 class="big-heading">{{ $t("stageOne.welcome") }}</h1>
          <div class="autocomplete-container">
            <p>{{ $t("stageOne.targetAdress") }}</p>
            <GMapAutocomplete
              placeholder=""
              @place_changed="setPlace"
              v-on:keyup.enter="onEnter"
              :options="{
                componentRestrictions: {
                  country: ['fi', 'ax', 'ee'],
                },
              }"
              style="margin-bottom: 0.5rem"
            />
            <button @click="useCurrentLocation" class="current-location-button">
              <img
                class="pinpoint-icon"
                src="../assets/icons/icon-pinpoint.svg"
              />
              {{ $t("stageOne.useCurrentLocation") }}
            </button>
          </div>
          <div class="nav-bottom">
            <el-button @click="changeStage(1)">
              {{ $t("general.continue") }}
              <img
                style="margin-left: 1rem"
                class="navigator-icon"
                src="/src/assets/icons/circle-arrow-right.svg"
              />
            </el-button>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script lang="ts" setup>
import type { google } from "google-maps";
import { useI18n } from "vue-i18n";

const emit = defineEmits(["emitAddress", "changeStage"]);

const { t } = useI18n();

function setPlace(e: google.maps.places.PlaceResult) {
  if (!e || !e.geometry) return;
  if (e.name && e.address_components) {

    let postCode = "";

    e.address_components.forEach(e => {
      if (e.types[0] === "postal_code"){
        postCode = e.long_name;
      }
    })

    emit(
      "emitAddress",
      e.geometry.location.lat(),
      e.geometry.location.lng(),
      e.name,
      postCode,
      e.address_components[2].long_name,
      false
    );
  } else {
    emit(
      "emitAddress",
      e.geometry.location.lat(),
      e.geometry.location.lng(),
      "",
      "",
      "",
      false
    );
  }
}

function onEnter() {
  emit("changeStage", 1);
}

function changeStage(i: number) {
  emit("changeStage", i);
}

function useCurrentLocation() {
  navigator.geolocation.getCurrentPosition(
    (position) => {
      emit(
        "emitAddress",
        position.coords.latitude,
        position.coords.longitude,
        "",
        "",
        "",
        true
      );
    },
    (error) => {
      console.log(error.message);
      alert(t("stageOne.locationError"));
    }
  );
}
</script>
